import { Navigate, useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { history } from '../helpers/history';



export { PrivateRoute };

function PrivateRoute({ children }) {

    // init custom history object to allow navigation from 
    // anywhere in the react app (inside or outside components)
    history.navigate = useNavigate();
    history.location = useLocation();
    const { user: authUser } = useSelector(x => x.user);


    //console.log(authUser);

    if (authUser && (authUser.length == 0 || authUser == null)) {
        // not logged in so redirect to login page with the return url
        return <Navigate to="/login" state={{ from: history.location, errorMessage: 'Please log in to access this page.' }} />
    }

    if (authUser && (authUser != null)) {
        // not logged in so redirect to login page with the return url
        //return <Navigate to="/login" state={{ from: history.location }} />
        // authorized so return child components
        return children;
    }

    return <Navigate to="/login" state={{ from: history.location, errorMessage: 'Please log in to access this page.' }} />
}